import { api } from "./client";

export function getAlerts() {
  return api.get("/alerts");
}

export function getAlertCount() {
  return api.get<{ count: number }>("/alerts/count");
}

export function dismissAlert(data: { alertKey: string }) {
  return api.post("/alerts/dismiss", data);
}

export function dismissAllAlerts() {
  return api.post("/alerts/dismiss-all");
}
